import { createSlice } from "@reduxjs/toolkit";
import {
  addUnranked,
  getUnranked,
  updateUnranked,
  deleteUnranked,
  toggleUnranked,
} from "./thunk";

const initialState = {
  unranked: [],
  loading: false,
  error: null,
  totalPages: 1,
  currentPage: 1,
};

const unrankedSlice = createSlice({
  name: "unranked",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ===== GET ALL =====
    builder
      .addCase(getUnranked.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUnranked.fulfilled, (state, action) => {
        state.loading = false;
        state.unranked = action.payload.data || [];
        state.totalPages =
          action.payload.responseDetails?.pagination?.totalPages || 1;
        state.currentPage =
          action.payload.responseDetails?.pagination?.currentPage || 1;
      })
      .addCase(getUnranked.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // ===== ADD =====
    builder.addCase(addUnranked.fulfilled, (state, action) => {
      state.unranked.unshift(action.payload);
    });

    // ===== UPDATE =====
    builder.addCase(updateUnranked.fulfilled, (state, action) => {
      const updatedId = action.payload._id;

      state.unranked = state.unranked.map((item) =>
        item._id === updatedId ? { ...item, ...action.payload } : item,
      );
    });

    // ===== TOGGLE ACTIVE =====
    builder.addCase(toggleUnranked.fulfilled, (state, action) => {
      const updatedId = action.payload._id;

      state.unranked = state.unranked.map((item) =>
        item._id === updatedId ? { ...item, ...action.payload } : item,
      );
    });

    // ===== DELETE =====
    builder.addCase(deleteUnranked.fulfilled, (state, action) => {
      state.unranked = state.unranked.filter(
        (item) => item._id !== action.payload.id,
      );
    });
  },
});

export default unrankedSlice.reducer;
